import Flickity from 'flickity';

// Fickity: touch, responsive carousel
Flickity.prototype._createResizeClass = function () {
    this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function () {
    this.element.classList.remove('flickity-resize');
    resize.call(this);
    this.element.classList.add('flickity-resize');
};

export default class TeaserCarrousel {
    constructor() {
        this.duration = 8;
        this.interval = 10;
        this.isPaused = false;
        this.percentTime = 0;
        this._carrousel = document.querySelector('.tc__content');
    }
    render() {
        if (this._carrousel) {
            this.createFlickity(this._carrousel);
            let tapArea, startX;
            tapArea = Array.from(document.querySelectorAll('.tc__teasers'));
            startX = 0;
            tapArea.forEach(function (item) {
                item.ontouchstart = function (e) {
                    startX = e.touches[0].clientX;
                };
                item.ontouchmove = function (e) {
                    if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
                        e.preventDefault();
                    }
                };
            });
            this._carrousel.addEventListener(
                'mouseenter',
                (e) => {
                    this.isPaused = true;
                },
                false,
            );
            this._carrousel.addEventListener(
                'mouseleave',
                (e) => {
                    this.isPaused = false;
                },
                false,
            );
            this._flktyDetail.on(
                'change',
                (e) => {
                    this.percentTime = 0;
                    this.setupBarState();
                },
                false,
            );
            this.startProgressbar();
        }
    }

    startProgressbar() {
        this.resetProgressbar();
        this.percentTime = 0;
        this.isPaused = false;
        this.tick = setInterval(this.increase.bind(this), this.interval);
    }
    setupBarState() {
        const lng = this._flktyDetail.slides.length;
        const index = this._flktyDetail.selectedIndex;
        for (let i = 0; i < lng; i++) {
            if (i < index) {
                this._carrousel.querySelector('.tc__indicator[data-ref="' + i + '"] span').style.width = '100%';
            } else if (i == index) {
                this._carrousel.querySelector('.tc__indicator[data-ref="' + i + '"] span').style.width =
                    this.percentTime + '%';
            } else {
                this._carrousel.querySelector('.tc__indicator[data-ref="' + i + '"] span').style.width = '0';
            }
        }
    }
    increase() {
        if (!this.isPaused) {
            const step = (this.duration * 1000) / this.interval;
            this.percentTime += 100 / step;
            this.setupBarState();
            if (this.percentTime >= 100) {
                this._flktyDetail.next();
                this.startProgressbar();
            }
        }
    }

    resetProgressbar() {
        clearTimeout(this.tick);
    }

    createFlickity(target) {
        const container = target.querySelector('.tc__teasers');
        this._flktyDetail = new Flickity(container, {
            cellSelector: '.tc__teaser',
            pageDots: false,
            wrapAround: true,
            prevNextButtons: false,
        });
    }
}
